<tp-page-scaffold [pageAvailability]="availability$ | async">
  <div class="scroll-box" (scroll)="checkScrollLocation($event)">
    <div class="drawer-container">
      <div class="drawer-content">
        <div class="drawer-section">
          <a class="active" routerLink=".">General</a>
          <a [class.active]="currentActive === 'details'" routerLink="." fragment="details">Account details</a>
          <a [class.active]="currentActive === 'mfa'" routerLink="." fragment="mfa">Multi-factor authentication</a>
          <a [class.active]="currentActive === 'profile-picture'" routerLink="." fragment="profile-picture">Profile picture</a>
          <a [class.active]="currentActive === 'teams'" routerLink="." fragment="teams">Teams</a>
          <a [class.active]="currentActive === 'invitations'" routerLink="." fragment="invitations">Invitations</a>
          <a [class.active]="currentActive === 'danger-zone'" routerLink="." fragment="danger-zone">Danger zone</a>
        </div>
      </div>

      <article>
        <h1>Account settings</h1>

        <section id="details">
          <div class="section-title-row">
            <h2>Account details</h2>
            <tp-button (click)="openEditDialog()" buttonStyle="secondary stroke" style="float: right" buttonId="editProfile">
              <i class="fa-light fa-pen-to-square"></i> Edit
            </tp-button>
          </div>
          <p class="tp-section-info">Configure your basic account details</p>

          @if (user$ | async; as user) {
            <tp-properties-table>
              <tp-properties-table-row key="Username">{{ user.id }}</tp-properties-table-row>
              <tp-properties-table-row key="Email">{{ user.email }}</tp-properties-table-row>
              <tp-properties-table-row key="First Name">{{ user.firstName }}</tp-properties-table-row>
              <tp-properties-table-row key="Last Name">{{ user.lastName }}</tp-properties-table-row>
            </tp-properties-table>
          } @else {
            <tp-spinner/>
          }
        </section>

        <section id="mfa">
          <div class="section-title-row">
            <h2>Multi-factor authentication</h2>
            @if (userMFAOptions.length) {
              <tp-button (click)="openUnenrollMFAModal()" buttonStyle="secondary stroke" style="float: right" buttonId="openMFA">
                <i class="fa-light fa-trash-can"></i> Remove MFA
              </tp-button>
            }
          </div>
          @if (!userMFAOptions.length) {
            <tp-integration-card faIconColor="#e96464" title="Enable MFA" faIcon="fa-thin fa-shield-exclamation" (click)="openMFADialog()">
              <p>Your account does not have MFA enabled. We <strong>strongly recommend</strong> enabling it to keep your account secure</p>
            </tp-integration-card>
          } @else {
            <tp-integration-card faIconColor="#78a0ff" [clickable]="false" title="MFA enabled" faIcon="fa-thin fa-shield-check">
              <p>Your account is protected with MFA</p>
            </tp-integration-card>
          }
        </section>

        <section id="profile-picture">
          <h2 class="section-title-row">Profile picture</h2>
          <aside>Profile pictures are managed through <a href="https://gravatar.com" target="_blank">Gravatar</a>.</aside>
        </section>

        <section id="teams">
          <tp-table-toolbar [table]="teams" filterGroupId="teams" tableTitle="Teams" [actions]="[teamCreationButton]" headerLevel="h2"/>
          <tp-teams-table [table]="teams"/>
          <tp-table-paginator [table]="teams"/>
        </section>

        <section id="invitations">
          <tp-table-toolbar [table]="invitations" filterGroupId="invitations" tableTitle="Invitations" headerLevel="h2"/>
          <tp-invitations-table [table]="invitations" [rowPopupMenuItems]="invitationsTableRowPopupMenuItems"/>
          <tp-table-paginator [table]="invitations"/>
        </section>

        <tp-delete-resource-section
          id="danger-zone"
          title="Danger zone"
          headerLevel="h2"
          [display]="{ text: 'Once you delete your account, there is no going back. Please be certain.' }"
          buttonText="Delete account"
          (buttonPressed)="showContactSupportDialog()"
          buttonIconClass="fa-light fa-trash-can"
        />
      </article>
    </div>
  </div>
</tp-page-scaffold>
